import classNames from 'clsx';
import React, { type ReactElement, memo } from 'react';
import { type ListChildComponentProps, areEqual } from 'react-window';
import { isScrollTopBtnEnabled } from 'reactApp/appHelpers/featuresHelpers/features/scrollTopBtn';
import {
    DATA_LIST_BREADCRUMBS_ID,
    DATA_LIST_EXTRABLOCKS_ID,
    DATA_LIST_GALLERY_TAB_MENU_ID,
    DATA_LIST_LAST_FILES_WIDGET_ID,
    DATA_LIST_PUBLIC_UPLOAD_HEADER_ID,
    DATA_LIST_STORIES_WIDGET_ID,
} from 'reactApp/ui/Datalist/DataList';
import { AdvBanner } from 'reactApp/ui/Mobile/Datalist/AdvBanner/AdvBanner';
import { VIRTUAL_LIST_LOADER_ID } from 'reactApp/ui/VirtualList/VirtualList.new';

import styles from './VirtualList.new.css';

export const VirtualListRow = memo(function VirtualListRow(props: ListChildComponentProps): ReactElement | null {
    const { index, style, data } = props;
    const { list, itemActiveIndex, renderItem, dividerSize, indexes } = data;
    const key = typeof list[index] === 'string' ? list[index] : list[index].id;
    const handleRef = index === itemActiveIndex ? data.handleRef : null;

    const extraBlocksInHead = list.filter((block) =>
        [
            DATA_LIST_BREADCRUMBS_ID,
            DATA_LIST_STORIES_WIDGET_ID,
            DATA_LIST_GALLERY_TAB_MENU_ID,
            DATA_LIST_PUBLIC_UPLOAD_HEADER_ID,
            DATA_LIST_LAST_FILES_WIDGET_ID,
        ].includes(block)
    ).length;

    const startIndex = indexes[index].start;
    const lastIndex = Math.min(indexes[index].end, list.length);

    const singleRowItem =
        startIndex === lastIndex &&
        [
            DATA_LIST_EXTRABLOCKS_ID,
            VIRTUAL_LIST_LOADER_ID,
            DATA_LIST_BREADCRUMBS_ID,
            DATA_LIST_STORIES_WIDGET_ID,
            DATA_LIST_GALLERY_TAB_MENU_ID,
            DATA_LIST_PUBLIC_UPLOAD_HEADER_ID,
            DATA_LIST_LAST_FILES_WIDGET_ID,
        ].includes(list[startIndex]);

    if (list[index].divider) {
        return (
            <div
                style={style}
                key={key + index}
                className={classNames(styles.dividerContainer, styles.dividerList, {
                    [styles.dividerAdv]: list[index].showAdv,
                })}
                data-qa-divider={list[index].text}
            >
                <div
                    className={classNames(styles.divider, {
                        [styles[`divider_${dividerSize}`]]: !!dividerSize,
                    })}
                >
                    {list[index].text}
                    {list[index].showAdv && <AdvBanner />}
                </div>
            </div>
        );
    }

    let styleLastItem;
    if (singleRowItem) {
        styleLastItem = { height: '100%' };

        // CLOUDWEB-18222: Чтобы кнопка скролла наверх не перекрывала элементы списка оставляем пустое пространство в конце даталиста
        if (isScrollTopBtnEnabled && DATA_LIST_EXTRABLOCKS_ID === list[index]) {
            styleLastItem = {
                ...styleLastItem,
                minHeight: '160px',
            };
        }
    }

    return (
        <div style={style} key={key + index} ref={handleRef}>
            <div className={styles.compensateScroll} style={styleLastItem}>
                {renderItem(data.list[index], { index: index - extraBlocksInHead })}
            </div>
        </div>
    );
}, areEqual);
